import { computed, unref } from "vue";
import { createClient } from "@supabase/supabase-js";
const supabase = createClient(
  "https://wmxsoyhjaulrzsxhhihd.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndteHNveWhqYXVscnpzeGhoaWhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTEyMTMyNzYsImV4cCI6MjAyNjc4OTI3Nn0.dOVUxMkgbkgJUUmJU4eta5JUdaupAB0lQHVrNDPGxcc",
  {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
    },
  }
);

import store from "@/store/index.js";

function goBack(router, backup) {
  if (window.history.state.back === null) {
    return router.push(backup);
  }

  window.history.back();
}

async function uploadFileHandler(type, evt) {
  console.log(type, evt);

  if (!evt.target.files || evt.target.files.length === 0) {
    throw new Error("Selecciona un archivo");
  }
  const file = evt.target.files[0];
  const fileExt = file.name.split(".").pop();
  const fileName = `${Math.random()}.${fileExt}`;
  const filePath = `${fileName}`;

  return await uploadFile(type, filePath, file);
}

async function authListener() {
  supabase.auth.onAuthStateChange((event, session) => {
    console.log(event, session);

    if (event === "INITIAL_SESSION") {
      // handle initial session
    } else if (event === "SIGNED_IN") {
      // handle sign in event
    } else if (event === "SIGNED_OUT") {
      // handle sign out event
    } else if (event === "PASSWORD_RECOVERY") {
      const accessToken = session.access_token;
      const refreshToken = session.refresh_token;

      session.user.session = {
        access_token: accessToken,
        refresh_token: refreshToken,
      };

      const persistedSession = {
        access_token: accessToken,
        refresh_token: refreshToken,
        user: session.user,
      };

      console.log("SAVING SESSION", persistedSession);
      localStorage.setItem(
        "enlazado_session",
        JSON.stringify(persistedSession)
      );
      store.commit("setSession", session);
    } else if (event === "TOKEN_REFRESHED") {
      // handle token refreshed event
    } else if (event === "USER_UPDATED") {
      // handle user updated event
    }
  });
}

async function uploadFile(type, filePath, file) {
  let { data, error } = await supabase.storage
    .from(type)
    .upload(filePath, file);

  console.log("uploadFile", data, error);
  if (data && data.fullPath) {
    return data.fullPath;
  } else if (error) {
    console.log("utils uploadFile", error);
    throw error;
  }
}

function getTransactionType(transactionType) {
  switch (transactionType) {
    case "ORDER":
      return "Order";
    case "IN":
      return "In";
    case "OUT":
      return "Out";
    case "ADJUST":
      return "Adjustment";
  }
}

function capitalize(str) {
  if (!str || typeof str !== "string") {
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function preventInvalidInput(event) {
  // Get the key that was pressed
  const key = event.key;

  // Allow: backspace, delete, tab, escape, enter, arrow keys
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "Escape",
    "Enter",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
  ];

  // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X (copy/paste operations)
  if (
    (event.ctrlKey || event.metaKey) &&
    ["a", "c", "v", "x", "A", "C", "V", "X"].includes(key)
  ) {
    return;
  }

  // Allow navigation and control keys
  if (allowedKeys.includes(key)) {
    return;
  }

  // Only allow numeric characters (0-9)
  if (!/^[0-9]$/.test(key)) {
    event.preventDefault();
  }
}

function validateQuantity(obj, key = "quantity") {
  // Convert to number and validate
  const value = parseFloat(obj[key]);

  // If the value is negative, set to the absolute value to make it positive
  if (!isNaN(value) && value < 0) {
    obj[key] = Math.abs(value);
  }

  // If it's a valid positive number, ensure it's an integer
  if (!isNaN(value) && value >= 0) {
    obj[key] = Math.floor(value);
  }

  // If the field is empty or NaN, leave it as is (don't force to 0)
}

function getDeniedPermissions(session, providerId) {
  if (!session || !providerId) {
    return [];
  }

  const memberships = Array.isArray(session.providers)
    ? session.providers
    : [];

  const target = memberships.find((record) => {
    if (!record) return false;

    const recordProviderId =
      record?.provider?.id ??
      record?.provider_id ??
      record?.provider?.provider_id ??
      null;

    return (
      recordProviderId &&
      String(recordProviderId) === String(providerId)
    );
  });

  const deniedList = target?.permissions_denied;

  return Array.isArray(deniedList) ? deniedList : [];
}

function useDeniedPermissions(store, providerIdRef) {
  return computed(() => {
    const providerId = unref(providerIdRef);
    const session = store?.state?.session || null;
    return getDeniedPermissions(session, providerId);
  });
}
const utils = {
  goBack: goBack,
  uploadFileHandler: uploadFileHandler,
  authListener: authListener,
  getTransactionType: getTransactionType,
  capitalize: capitalize,
  preventInvalidInput: preventInvalidInput,
  validateQuantity: validateQuantity,
  getDeniedPermissions,
  useDeniedPermissions,
};

export default utils;

export { supabase as supabaseClient, getDeniedPermissions, useDeniedPermissions };
